import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import hoverEffect from '../components/hover'



class Projects extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.index = 0


    this.ref = {
      project: [],
      video: [],
      container:  []
    }

  }

  mount() {

    _each(this.ref.project, (item, index)=>{

        const ratio = item.dataset.ratio || 1.25
        
        var button = new hoverEffect({
          parent: item,
          image1: item.dataset.image,
          image2: item.dataset.image,
          imagesRatio: ratio,
          displacementImage: item.dataset.disp
        });


    })

    

    _each(this.ref.container, (item, index) => {
       ScrollTrigger.create({
         trigger: item,
         start: "top bottom",
         id: `proj${index}`,
         onEnter: ({
           progress,
           direction,
           isActive
         }) => {
           item.classList.add("inview")
         },
         onLeaveBack: ({
           progress,
           direction,
           isActive
         }) => {
           item.classList.remove("inview")
         }
       });
    })
  


    
}






  unmount() {

    _each(this.ref.container, (item, index) => {
      ScrollTrigger.getById(`proj${index}`).kill();
    })

    _each(this.ref.project, (item, index) => {

      var button = null


    })

    


  }


}

module.exports = Projects
